__turbopack_context__.v({
  "badge": "FormTip-module-scss-module__35gBMW__badge",
  "badge_list": "FormTip-module-scss-module__35gBMW__badge_list",
  "card": "FormTip-module-scss-module__35gBMW__card",
  "card_info": "FormTip-module-scss-module__35gBMW__card_info",
  "card_slide": "FormTip-module-scss-module__35gBMW__card_slide",
  "card_title": "FormTip-module-scss-module__35gBMW__card_title",
  "cards": "FormTip-module-scss-module__35gBMW__cards",
  "cards_swiper": "FormTip-module-scss-module__35gBMW__cards_swiper",
  "col": "FormTip-module-scss-module__35gBMW__col",
  "col_head": "FormTip-module-scss-module__35gBMW__col_head",
  "col_item": "FormTip-module-scss-module__35gBMW__col_item",
  "compare": "FormTip-module-scss-module__35gBMW__compare",
  "copy": "FormTip-module-scss-module__35gBMW__copy",
  "head": "FormTip-module-scss-module__35gBMW__head",
  "more_button": "FormTip-module-scss-module__35gBMW__more_button",
  "narrow": "FormTip-module-scss-module__35gBMW__narrow",
  "nav": "FormTip-module-scss-module__35gBMW__nav",
  "nav_next": "FormTip-module-scss-module__35gBMW__nav_next",
  "nav_prev": "FormTip-module-scss-module__35gBMW__nav_prev",
  "original": "FormTip-module-scss-module__35gBMW__original",
  "pass_icon": "FormTip-module-scss-module__35gBMW__pass_icon",
  "price": "FormTip-module-scss-module__35gBMW__price",
  "product_badge": "FormTip-module-scss-module__35gBMW__product_badge",
  "root": "FormTip-module-scss-module__35gBMW__root",
  "swiper": "FormTip-module-scss-module__35gBMW__swiper",
  "thumb": "FormTip-module-scss-module__35gBMW__thumb",
  "tip_individual": "FormTip-module-scss-module__35gBMW__tip_individual",
  "tip_lounge": "FormTip-module-scss-module__35gBMW__tip_lounge",
  "unlimited": "FormTip-module-scss-module__35gBMW__unlimited",
  "weekend": "FormTip-module-scss-module__35gBMW__weekend",
});
